import React from "react";
import { ReactComponent as Loading } from "../../assets/loading-blue.svg";

import styles from "./style.module.scss";

const LoadingSpinner: React.FC = () => {
  return <Loading className={styles.loading} />;
};

export default LoadingSpinner;
